import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";

import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { FieldElementBlock } from "../../blocks/shared/components/FieldElementBlock";
import { useBlocksContext } from "../../contexts/BlocksContext";

interface NameBlockMeta {
  elementableId: number;
  elementId: number;
  fieldIndex: number;
  position: number;
}
export interface FormContactNameBlockProps extends ComponentPropsWithRef<"div"> {
  blockInstanceMeta?: NameBlockMeta;
  hidden?: boolean;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormContactNameBlock = forwardRef<
  HTMLDivElement,
  FormContactNameBlockProps
>(
  (
    {
      label = t("settings.forms.default_contact_name_label"),
      placeholder = "",
      required = false,
      hidden = false,
      blockInstanceMeta = {},
      ...rest
    },
    ref,
  ) => {
    const { useFormRenderingContext } = useBlocksContext();
    const context = useFormRenderingContext();
    const { currentCommunityMember } = usePunditUserContext();

    const shouldPrefillAndDisable =
      !context.isPreview && Boolean(currentCommunityMember?.name);

    return (
      <FieldElementBlock
        ref={ref}
        blockInstanceMeta={blockInstanceMeta}
        fieldType="contact_name"
        hidden={hidden}
        label={label}
        placeholder={placeholder}
        required={required}
        disabled={shouldPrefillAndDisable}
        fieldDefaultValue={
          shouldPrefillAndDisable ? currentCommunityMember?.name : undefined
        }
        {...rest}
      />
    );
  },
);

FormContactNameBlock.displayName = "FormContactNameBlock";
